import { render, staticRenderFns } from "./PrestataireView.vue?vue&type=template&id=7f8a3c97&scoped=true&"
import script from "./PrestataireView.vue?vue&type=script&lang=js&"
export * from "./PrestataireView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f8a3c97",
  null
  
)

export default component.exports